import { Fragments } from "requests";
import { FormValues } from "./types";

const resolveZero = (val: number | null | undefined) => {
  if (val == null) {
    return null;
  }
  return val;
};

export const getDefaultValues = (
  dentalChart: NonNullable<Fragments.StoredDentalChartings>[number] | null
): FormValues | null => {
  if (!dentalChart) {
    return null;
  }

  return {
    toothState: dentalChart.toothState || null,
    periodontal: dentalChart.periodontal || null,
    furcation: dentalChart.furcation || null,
    mobility: dentalChart.mobility || null,
    gingivitis: dentalChart.gingivitis || null,
    calculus: dentalChart.calculus || null,
    enamel: dentalChart.enamel || null,
    fracture: dentalChart.fracture || null,
    resorption: dentalChart.resorption || null,
    other: dentalChart.other || [],

    periodontalPocketMBuc: resolveZero(dentalChart.periodontalPocketMBuc),
    periodontalPocketBuccal: resolveZero(dentalChart.periodontalPocketBuccal),
    periodontalPocketDBuc: resolveZero(dentalChart.periodontalPocketDBuc),
    periodontalPocketMLingPal: resolveZero(
      dentalChart.periodontalPocketMLingPal
    ),
    periodontalPocketLingPal: resolveZero(dentalChart.periodontalPocketLingPal),
    periodontalPocketDLingPal: resolveZero(
      dentalChart.periodontalPocketDLingPal
    ),

    gingivalRecessionMBuc: resolveZero(dentalChart.gingivalRecessionMBuc),
    gingivalRecessionBuccal: resolveZero(dentalChart.gingivalRecessionBuccal),
    gingivalRecessionDBuc: resolveZero(dentalChart.gingivalRecessionDBuc),
    gingivalRecessionMLingPal: resolveZero(
      dentalChart.gingivalRecessionMLingPal
    ),
    gingivalRecessionLingPal: resolveZero(dentalChart.gingivalRecessionLingPal),
    gingivalRecessionDLingPal: resolveZero(
      dentalChart.gingivalRecessionDLingPal
    )
  };
};
